import '/style/utils/ghostfollowerelement.scss'

type Relocate = {
    top: number, left: number, right: number, bottom: number
}
interface IGhostFollowerElementExtras {
    scrollReferences?: HTMLElement[]
    onCalcRelocateGhost?: (referenceRect: DOMRect, ghost: HTMLElement) => (
        (Pick<Relocate, "top"> & Partial<Pick<Relocate, "left">>)
        | (Pick<Relocate, "top"> & Partial<Pick<Relocate, "right">>)
        | (Pick<Relocate, "bottom"> & Partial<Pick<Relocate, "left">>)
        | (Pick<Relocate, "bottom"> & Partial<Pick<Relocate, "right">>)
        | (Pick<Relocate, "left"> & Partial<Pick<Relocate, "top">>)
        | (Pick<Relocate, "left"> & Partial<Pick<Relocate, "bottom">>)
        | (Pick<Relocate, "right"> & Partial<Pick<Relocate, "top">>)
        | (Pick<Relocate, "right"> & Partial<Pick<Relocate, "bottom">>)
    )
}
export class GhostFollowerElement {
    private ghost: HTMLElement
    private reference: HTMLElement
    private extras: IGhostFollowerElementExtras

    constructor(ghost: HTMLElement, reference: HTMLElement, extras?: IGhostFollowerElementExtras) {
        this.ghost = ghost;
        this.reference = reference;
        this.extras = extras || {};

        if (!this.ghost || !this.reference) {
            console.error("Elementos no encontrados");
            return;
        }

        reference.classList.add("ghostfollower-ghostly-mark")
        ghost.classList.add("ghostfollower-ghost")

        this.extras.scrollReferences?.forEach((el) => el.addEventListener("scroll", () => this.Refresh()))
        window.addEventListener("resize", () => this.Refresh());
        requestAnimationFrame(() => this.Refresh());
    }

    private Refresh() {
        if (!this.reference.isConnected || !this.ghost.isConnected) {
            return
        }
        const rect = this.reference.getBoundingClientRect();
        if (!this.extras.onCalcRelocateGhost) {
            this.ghost.style.left = `${rect.left}px`;
            this.ghost.style.top = `${rect.top}px`;
        } else {
            const relocate = this.extras.onCalcRelocateGhost(rect, this.ghost);
            for (const key in relocate) {
                this.ghost.style[key] = `${relocate[key]}px`;
            }
        }
    }

    public _Refresh(): this {
        this.Refresh();
        return this;
    }
}